import axios from 'axios';
import { attachInterceptors } from './interceptors';
import { demoAdapter } from '../demo/mockApi';
import { canManageAccess, getAdminToken, getAdminViewAs } from '../utils/adminSession';

/**
 * Standalone frontend DEMO mode. When REACT_APP_DEMO=true every backend call is
 * answered locally by `src/demo/mockApi.js` — no backend and no real auth needed.
 * Must be false/unset for uat and production builds.
 */
export const isDemoMode = String(process.env.REACT_APP_DEMO).toLowerCase() === 'true';
export const isTestMode = String(process.env.REACT_APP_TEST_MODE).toLowerCase() === 'true';

/** Re-enrolment backend (existing APIs) */
export const reenrolmentApi = attachInterceptors(
    axios.create({
        baseURL: process.env.REACT_APP_REENROLMENT_API_BASE_URL,
    })
);

if (isDemoMode) {
    // eslint-disable-next-line no-console
    console.info('[DEMO MODE ACTIVE] Backend API requests are mocked locally via demoAdapter.');
    reenrolmentApi.defaults.adapter = demoAdapter;
}


/**
 * Staff tools (the approval list and approving a record).
 *
 * A separate client because these carry the staff sign-in, not a parent session — the two must
 * never be sent to the wrong place. The token is read per request so signing in or out takes
 * effect immediately.
 */
export const adminApi = axios.create({
    baseURL: process.env.REACT_APP_REENROLMENT_API_BASE_URL,
});

adminApi.interceptors.request.use((config) => {
    const token = getAdminToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    // An access manager looking as one team does. The server ignores it for anybody else.
    const viewAs = canManageAccess() ? getAdminViewAs() : '';
    if (viewAs) {
        config.headers['X-View-As'] = viewAs;
    }
    return config;
});

if (isDemoMode) {
    adminApi.defaults.adapter = demoAdapter;
}

// Keep default export for existing `import URL2 from './config'` usages
export default reenrolmentApi;
